import React from "react";
import { PlusCircleIcon } from "./icons/PlusCircleIcon";
import FormularioDirecto from "../FormularioDirecto";

export default function AddQuestionModule() {
  return (
    <div className="w-full max-w-5xl mx-auto">
      <header className="flex items-center gap-3 mb-4">
        <PlusCircleIcon className="w-8 h-8 text-primary" />
        <div>
          <h3 className="font-bold text-lg text-white">Agregar Pregunta</h3>
          <p className="text-gray-400 text-sm">Introduce nuevas preguntas al sistema de forma directa.</p>
        </div>
      </header>
      <FormularioDirecto />
    </div>
  );
}
